import { matchObject } from "./matchObject";

/**
 * Returns a filter function that will return true if the given object matches the query
 *
 * @param {object} query Query to match
 * @returns function
 */

export function createMatchObjectFilter(query) {
    /**
     * Returns true if object matches the given query
     * @param {object} object       Object to test
     * @returns boolean
     */
    return function (object) {
        return matchObject(query, object);
    };
}
